import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

import { FeedbackProvider } from '../providers/feedback-provider';
import { Feedback } from "../../common/models/feedback";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class FeedbackResolver implements Resolve<Feedback> {
    constructor(
        private feedbackProvider: FeedbackProvider
    ) { }

    public resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> {
        return this.feedbackProvider.getByType(route.params['feedbackType']);
    }
}
